import {Component, Input, Output, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MatSliderChange, MatSnackBar} from '@angular/material';
import {ActivatedRoute, Router} from '@angular/router';
import {MapTab, MapComponent, ClickDisplay} from '../../map.component'
import {
  FourDService,
  Annotation
} from '4d-mapper'

import {MapService} from '../../../../commons/map.service';
import {AppService} from '../../../../commons/app.service';
import {BaseComponent} from '../../../../commons/BaseComponent';
import { Subscription } from 'rxjs';
import { InspectionComponent } from '../inspect.component';
import { APITypes } from '../../../../commons/global';
import {EntityHelperService} from '../../../../service/entity-helper.service';
import { XsApplicationEventsService } from '../../../../xs/services/events/application-events.service';

const Cesium = (<any>window).Cesium;

@Component({
  selector: 'pp-list-comp',
  templateUrl: './pp.component.html',
  styleUrls: ['./pp.component.scss','../../map_commons.scss']
})
export class PPListComponent extends BaseComponent implements OnInit, OnDestroy, MapTab {

  rovers:Annotation[] = []
  stations:Annotation[] = []

  interval:NodeJS.Timer;

  constructor(private route: ActivatedRoute, public router: Router, private fourD: FourDService, snackBar: MatSnackBar, dialog: MatDialog, 
    public entityHelper:EntityHelperService, public mapService: MapService, public service: AppService, applicationEvents:XsApplicationEventsService) {
    super(router, snackBar, dialog)
    console.log ( 'pp.component CONSTRUCTOR', this);
  }
  
  init() {
    // position aprtenrs only mod, just enabled this on labs!
    return;
    this.interval = setInterval(() => this.refreshSensors(),30000)
  }
  destroy(){
    clearInterval(this.interval)
  }
  
  clickedMap(movement, rightClick:boolean, checkedPosition):ClickDisplay{
    return ClickDisplay.None
  }

  private mapComp:MapComponent
  becameActive(mapComp:MapComponent){
    this.mapComp = mapComp
    this.fourD.onReady().subscribe(_ => 
      this.mapService.onReady().subscribe(_ => 
        this.refreshSensors()
      )
    )
  }
  becameInactive(mapComp:MapComponent){
  }

  refreshSensors(){
    var apiType = this.mapService.fourD.apis.find(a => a.processorImpl == APITypes.PositionPartners.IMPL)

    if ( !apiType || ! apiType.id ) {
      return;
    }

      this.fourD.V.api('/remote/' + apiType.id + '/api/v1/overview').subscribe(s => {

        this.mapService.annotations = this.mapService.annotations.filter(a => this.rovers.indexOf(a) == -1 && this.stations.indexOf(a) == -1 )

        this.rovers = s.rovers.map((r,i) => {
          var a = new Annotation(this.fourD.V)
          a.id = -i
          a.name = r.name
          a['attributes'] = Object.keys(r).map(k => {
            return {
              key:k,
              value:r[k]
            }
          })
          a.annotationMode = 'pp'
          a.ulat = r.position.latitude*180/Math.PI
          a.llat = r.position.latitude*180/Math.PI
          a.ulng = r.position.longitude*180/Math.PI
          a.llng = r.position.longitude*180/Math.PI
        //  a.uheight = r.position.altitude
        //  a.lheight = 300
          a['icon'] = 'crosshairs'
          this.mapService.annotations.push(a)
          this.mapService.helper.addPlottable(a).subscribe(res =>
            res.object.pin.billboard.image = this.entityHelper.getPinImage(res.plottable)
          )
          return a
        })



        this.stations = s.stations.map((r,i) => {
          var a = new Annotation(this.fourD.V)
          a.id = -(1 + i)*10000
          a.name = r.name
          a['attributes'] = Object.keys(r).map(k => {
            return {
              key:k,
              value:r[k]
            }
          })
          a.annotationMode = 'pp'
          a.ulat = r.position.latitude*180/Math.PI
          a.llat = r.position.latitude*180/Math.PI
          a.ulng = r.position.longitude*180/Math.PI
          a.llng = r.position.longitude*180/Math.PI
        //  a.uheight = r.position.altitude
         // a.lheight = 300
          a['icon'] = 'wifi'
          this.mapService.annotations.push(a)
          this.mapService.helper.addPlottable(a).subscribe(res =>
            res.object.pin.billboard.image = this.entityHelper.getPinImage(res.plottable)
          )
          return a
        })
        
          
      },e =>

          this.openSnackBarError('GENERIC.CONNECT_ERROR2'+ e)
      )

  }

}

